"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Renders the content of a notification for a file upload.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.file - The file object.
 * @param {string} props.children - The content to be displayed.
 * @param {string} props.color - The color of the typography.
 * @param {React.Ref} ref - The ref to be forwarded to the Typography component.
 * @returns {JSX.Element} The rendered NotificationContent component.
 */const NotificationContent = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    file,
    color,
    children
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography.default, {
    tokens: {
      color
    },
    ref: ref,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
      variant: {
        bold: true
      },
      tokens: {
        color
      },
      children: file.name
    }), children]
  });
});
NotificationContent.displayName = 'NotificationContent';
NotificationContent.propTypes = {
  /**
   * The file object.
   */
  file: _propTypes.default.object,
  /**
   * The content to be displayed.
   */
  children: _propTypes.default.string,
  /**
   * The color of the typography.
   */
  color: _propTypes.default.string
};
var _default = exports.default = NotificationContent;